<template>
  <div>
    <form class="form-horizontal" id="form-apunte" action="" @submit.stop.prevent="enviarApunte" novalidate>

      <div class="card">
        <h5 class="card-header bg-secondary text-white">Nuevo apunte</h5>
        <div class="card-body">
          <fieldset>

          <div class="form-group row">
            <label class="col-md-2 col-form-label" for="tipo-apunte">Tipo</label>
            <div class="col-md-5">
              <select id="tipo-apunte" class="select form-control" name="tipo-apunte" v-model="apunte.tipo">
                <option value="ingreso">Transferencia o ingreso</option>
                <option value="metalico">Pago en metálico</option>
                <option value="varios">Otros</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-md-2 col-form-label" for="importe">Importe</label>
            <div class="col-md-5">
              <input id="importe" name="importe" type="text" class="form-control" required="true" v-model="apunte.importe">
            </div>
          </div>

          <div id="bloque-fecha" :class="apunte.tipo == 'varios' ? 'd-none' : 'd-block'">
            <div class="form-group row">
              <label class="col-md-2 col-form-label" for="fecha">Fecha</label>
              <div class="col-md-5">
                <input id="fecha" name="fecha" type="text" class="form-control" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" v-model="apunte.fecha">
              </div>
            </div>
          </div>

          <div id="bloque-concepto" :class="apunte.tipo == 'varios' ? 'd-block' : 'd-none'">
            <div class="form-group row">
              <label class="col-md-2 col-form-label" for="concepto">Concepto</label>
              <div class="col-md-5">
                <input id="concepto" name="concepto" type="text" class="form-control" v-model="apunte.concepto">
              </div>
            </div>
          </div>

          </fieldset>

          <button type="submit" class="btn btn-primary">Guardar</button>

        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { api } from '../api/api.js';

export default {
	name: 'AdminNuevoApunte',
	props: [ 'id_familia' ],
	data () {
		return {
			apunte: {
				tipo: null,
				importe: null,
				fecha: null,
				concepto: null,
			},
		}
	},
	created () {
	},
	methods: {
		enviarApunte() {
			api(`/familias/${this.id_familia}/apunte`, 'POST', this.apunte)
                .then((data) => {
                    console.log(data);
					this.$router.push(`/admin/familia/${this.id_familia}/balance`);
                })
                .catch((error) => {
                    this.mensaje_error = error;
                });
		}
	},
}
</script>
